import { appDispatcher } from '../../application/AppDispatcher'
const { view: dispatchViewAction } = appDispatcher.dispatchAction
import { namespacedConsts } from '../../utils/object'
export const BROWSI_ACTIONS = namespacedConsts({
  ACTIONS: {
    SCRIPT_LOAD: {
      BEFORE: true,
      AFTER: true,
    },
  },
})
const { ACTIONS } = BROWSI_ACTIONS
const { BEFORE, AFTER } = ACTIONS.SCRIPT_LOAD
export const scriptLoadingStart = dispatchViewAction.part({ type: BEFORE })
export const scriptLoadingEnd = dispatchViewAction.part({ type: AFTER })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/browsiActions.js